import { CREDIT_PRICING } from '@arnold/core';
import { TopicGroupTypeCode } from '../generated/hooks';

const CREDIT_PRICE_BY_TYPE: Partial<Record<TopicGroupTypeCode, number>> = {
  [TopicGroupTypeCode.Onboarding]: CREDIT_PRICING.ONBOARDING,
  [TopicGroupTypeCode.Exit]: CREDIT_PRICING.EXIT,
  [TopicGroupTypeCode.Pulse]: CREDIT_PRICING.PROCESS,
  [TopicGroupTypeCode.Pulser]: CREDIT_PRICING.PULSER,
};

export const ONE_TIME_SURVEY_CREDIT_PRICE = CREDIT_PRICING.ONE_TIME;
export const ONE_TIME_PULSER_SURVEY_CREDIT_PRICE = CREDIT_PRICING.PULSER;

export function getCreditPriceForSurveyGroup(typeCode?: TopicGroupTypeCode | null): number | null {
  if (!typeCode) return CREDIT_PRICING.PROCESS;
  return CREDIT_PRICE_BY_TYPE[typeCode] ?? CREDIT_PRICING.PROCESS;
}
